import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = {
  categories: {
    title: '影片分类',
    items: categories.slice(0, 4),
  },
  more: {
    title: '更多资源',
    items: [
      { name: '纪录片', path: '/category/documentary' },
      { name: '短剧', path: '/category/short' },
      { name: '最新更新', path: '/category/movie?sort=new' },
      { name: '高分推荐', path: '/category/movie?sort=rating' },
    ],
  },
  about: {
    title: '关于我们',
    items: [
      { name: '品牌介绍', path: '/about' },
      { name: '用户口碑', path: '/about#reputation' },
      { name: '联系我们', path: '/about#contact' },
      { name: '常见问题', path: '/about#faq' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-flex items-center gap-2 mb-4">
                <span className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
                  <i className="ri-leaf-line mr-1"></i>
                  小草影院
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed mt-2">
                小草影院致力于为您提供免费、高清、流畅的在线观影体验。全站资源无需注册，即点即看，不缓冲秒开播，让您畅享影视盛宴。
              </p>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.items.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/40">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 小草影院 xiaocaoyingyuan.com - 本站所有资源均来自互联网，仅供学习交流使用
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-500">关注我们</span>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-800/30 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-800/30 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-800/30 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}